import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from 'utils/hooks/useAuth';
import { openPopup } from 'modules/popup/actions';
import { selectIsAnyPopupShown } from 'modules/popup/popup.selectors';
import { POPUP } from 'utils/constants/popup';
import { noop } from 'functions/noop';

const POPUP_DISPLAYING_TIMEOUT = 1000;

export const useProfileChanged = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const seeAllOptionsPopupShownRef = useRef(false);
  const { data: { providersPopup: { noProvidersMatched } = {} } } = useSelector((state) => state.profile);
  const isAnyPopupShown = useSelector((state) => selectIsAnyPopupShown(state));

  const shouldShowSeeAllOptionsPopup = !!(
    isAuthenticated && !isAnyPopupShown && noProvidersMatched && !seeAllOptionsPopupShownRef.current
  );

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }
    // init render / logout
    seeAllOptionsPopupShownRef.current = false;
  }, [isAuthenticated]);

  useEffect(() => {
    if (!shouldShowSeeAllOptionsPopup) {
      return noop;
    }

    const popupTimeout = setTimeout(() => {
      dispatch(openPopup({ type: POPUP.SEE_ALL_OPTIONS }));
      seeAllOptionsPopupShownRef.current = true;
    }, POPUP_DISPLAYING_TIMEOUT);

    return () => {
      if (popupTimeout) {
        clearTimeout(popupTimeout);
      }
    };
  }, [dispatch, shouldShowSeeAllOptionsPopup]);
};
